import React from 'react';

import { ADMIN_TIME_OFF, ADMIN_TIME_OFF_PAYWALL } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { SparkleIcon } from '@Generic/icons';

const TimeOffPaywallPage = React.lazy(() => import('../../../pages/Admin/TimeOffPaywall'));

export default {
  label: 'time-off.admin-page.title',
  group: ADMIN,
  to: '/administration/time-off-paywall',
  route: '/administration/time-off-paywall',
  component: TimeOffPaywallPage,
  icon: <SparkleIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_TIME_OFF,
  area: ADMIN_TIME_OFF_PAYWALL,
  hasNavBar: true,
};
